export default __webpack_public_path__ + "static/hookathon-2aac230a32e9eb04cc7294d6044a9c0c.png";